import styled from "styled-components";

export const Styles = styled.div`
  padding: 0rem;

  .table {
    border: 1px solid #ddd;
    .th {
      overflow: unset !important;
      background-color: #fff;
    }
    .tr {
      .td {
        background-color: #fff;
      }
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
      :hover {
        background-color: rgba(33, 150, 243, 0.1);
        cursor: pointer;
      }
    }

    .th,
    .td {
      padding: 5px;
      border-bottom: 1px solid #ddd;
      border-right: 1px solid #ddd;
      overflow: hidden;
      background-color: #fff;

      :last-child {
        border-right: 0;
      }

      .resizer {
        display: inline-block;
        width: 5px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;
        ${"" /* prevents from scrolling while dragging on touch devices */}
        touch-action:none;
        &.isResizing {
          background: red;
        }
      }
    }

    &.sticky {
      overflow: auto;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }

      .header {
        top: 0;
        box-shadow: 0px 3px 3px #ccc;
        .tr:hover {
          background-color: unset;
        }
      }

      .footer {
        bottom: 0;
        box-shadow: 0px -3px 3px #ccc;
      }

      .body {
        position: relative;
        z-index: 0;
      }

      [data-sticky-td] {
        position: sticky;
      }

      [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px #ccc;
      }

      [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px #ccc;
      }
    }
  }
  // .footer {
  //   width: 100%;
  //   background-color: #fff;
  //   padding: 10px;
  //   display: flex;
  //   flex-wrap: wrap;
  //   justify-content: space-around;
  //   align-items: center;
  //   border: 1px solid #ddd;
  // }
  .actionsDot {
    text-align: center;
    color: #00d8db;
    font-size: 22px;
    margin-top: -13px;
    cursor: pointer;
  }
  .ageBar {
    background: red;
    padding: 5px;
    text-align: right;
  }
`;
